import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { View, BodyText, InlineText, Row, InlineLink } from 'modules/styled';
import SocialIcons from 'modules/navigation/social.icons';
import { SIDE_NAV_PADDING } from 'styles/layout';
import { useDispatch } from 'react-redux';
import { goToUrl } from 'modules/navigation/navigation.actions';

const SideNavFooter = ({ actions }) => {
  const dispatch = useDispatch();
  return (
    <View sx={{ m: [2, SIDE_NAV_PADDING], mb: 8 }}>
      <SocialIcons actions={actions} />
      <Row sx={{ mt: 3 }}>
        <InlineLink
          inline={1}
          to="/info/faq"
          nativeAction={() => dispatch(goToUrl('https://relevant.community/info/faq'))}
          external={true}
        >
          <BodyText sx={{ color: 'blue' }}>FAQ</BodyText>
        </InlineLink>
        <InlineText> | </InlineText>
        <InlineLink
          inline={1}
          to="https://relevant.community//eula.html"
          external
          target="_blank"
        >
          <BodyText sx={{ color: 'blue' }}>Content Policy</BodyText>
        </InlineLink>
        <InlineText> | </InlineText>
        <InlineLink
          inline={1}
          external
          to="https://relevant.community//privacy.html"
          target="_blank"
        >
          <BodyText sx={{ color: 'blue' }}>Privacy Policy</BodyText>
        </InlineLink>
      </Row>
      <BodyText sx={{ mt: 2 }}>© 2020 Relevant Protocols Inc.</BodyText>
    </View>
  );
};

SideNavFooter.propTypes = {
  actions: PropTypes.object,
};

export default memo(SideNavFooter);
